'use client';
import { Option } from 'effect';

import {
  contentBlockProductsPageSearchParamAtomFamily,
  createContentBlockProductsPageKey,
} from '@vs-shop/engine/atom/products/contentBlockProductsPagination';
import { fetchProductsByCodesPageAtom } from '../../../effect/atom/products/fetchProductsByCodesPage';
import type { ProductBase } from '../../../effect/schema/openapi/backend';
import type { HydraCollectionResponseType } from '@vs-shop/schemas/openapi/response';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomInitialValues } from '@effect/atom-react';

type Props = {
  blockIndex: number;
  codes: readonly string[];
  page: number;
  itemsPerPage: number;
  initialProductsData: HydraCollectionResponseType<typeof ProductBase>;
};

export default function ContentBlockProductsContextInitializer({
  blockIndex,
  codes,
  page,
  itemsPerPage,
  initialProductsData,
}: Props) {
  const pageKey = createContentBlockProductsPageKey(blockIndex);
  const pageSearchParamAtom = contentBlockProductsPageSearchParamAtomFamily(pageKey);

  useAtomInitialValues([
    [pageSearchParamAtom, page === 1 ? Option.none() : Option.some(page)],
    [
      fetchProductsByCodesPageAtom(codes, page, itemsPerPage),
      AsyncResult.success(initialProductsData),
    ],
  ]);

  return null;
}
